<div id="tender-contract-dashboard-index-analysis-list" class="container-fluid mt-5">
  <h1 class="page-title mb-3">List Index View</h1>

  <div class="row">
    <div class="col-3">
      <div class="form-group me-1">
        <jft-currency-select [currencyId]="currencyId" (onChange)="onCurrencyChange($event)"></jft-currency-select>
      </div>
    </div>
    <div class="col-2">
      <div class="form-group me-1">
        <jft-units-select [unitId]="unitId" (onChange)="onUnitChange($event)"></jft-units-select>
      </div>
    </div>
    <div class="col-2">
      <div class="form-group me-1">
        <jft-index-date-range [dateRange]="dateRange ? dateRange.code : ''"
          (onDates)="onDateRange($event)"></jft-index-date-range>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-8">
      <div class="form-group me-2">
        <jft-index-platts-select [buttonText]="'Add'" [clearSelected]="false"
          (onAdd)="addPlatts($event)"></jft-index-platts-select>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-lg-12 mb-3">
      <div class="card bg-white">
        <ul class="list-group list-group-flush border-top" *ngIf="!roundIndexPriceAverage || !roundIndexPriceAverage.length">
          <li class="list-group-item  d-flex align-items-center min-height">No data to display</li>
        </ul>
        <!--                todo partially loading icon move to component-->
        <div *ngIf="loading" class="d-flex justify-content-center" style="position: absolute; top: 25%; left: 49%;">
          <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="true" class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Symbol</th>
                <th>Bate</th>
                <th>Date Range</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of indexPriceAverageFiltered">
                <td>
                  <div>{{item.index?.getLabel()}}</div>
                  <div *ngFor="let offer of item['offers']">
                    <div *ngIf="offer.supplier">
                      <strong>{{offer.supplier.name}} - {{offer.name}}</strong>
                    </div>
                  </div>
                </td>
                <td>{{item.bate.name}}</td>
                <td>
                  <div>{{item.dateRange.name}}</div>
                  <div *ngIf="item.dateRangeStart && item.dateRangeEnd" class="small">
                    <jft-datetime [date]="item.dateRangeStart"></jft-datetime>
                    -
                    <jft-datetime [date]="item.dateRangeEnd"></jft-datetime>
                  </div>
                </td>
                <td>{{item.price}} {{item.units.code}} / {{item.currency.code}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>
